import React, { Component } from "react";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

class StepHeader extends Component {
	constructor(props) {
		super(props);
	}
	
	render() {
//		console.log('render [StepHeader]');
		let products = [];
		let clase = this.props.active ? "setep_indexA":"setep_indexI"
		let index = this.props.first && <span class={clase}>{this.props.index}</span>
		return (
			<div class="step_header">
			{index}<span class="setep_title">{this.props.title}</span>
			</div>
		);
	}
}

export default StepHeader;